import { useEffect, useState } from "react";
import { useAuth } from "./useAuth";
import * as globals from "../globals";
import * as restMethods from "../api/restMethods";

const getTeamUsers = async (auth, team_id) => {
    const url = `${globals.apiRoot}/team/${team_id}/users`;
    var response = await restMethods.getJson(auth, url);
    return await response.json();
}


export const useTeamUsers = (team_id) => {

    // TODO: move this into REDUX to eliminate fetches each time?
    // But if so, the websocket might need to cooperate to notify of changes

    const auth = useAuth();
    const [users, setUsers] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [refreshCounter, setRefreshCounter] = useState(0);

    useEffect(() => {

        const f = async () => {
            setLoading(true);
            try {
                const list = await getTeamUsers(auth, team_id);
                setUsers(list);
            }
            catch (err) {
                console.error(err);
                setError(err.message);
                setUsers([]);
            }
            setLoading(false);
        }
        f();

    }, [refreshCounter]);

    const refresh = () => setRefreshCounter(refreshCounter+1);

    return [users, loading, error, refresh]

}